export const mutations = {
  setPersons: (state, data) => {
    state.persons = data;
  },
}